<script lang="ts">
	import Icon from '@isoftdata/svelte-icon'
	interface Props {
		isPinned?: boolean
	}

	let { isPinned = false }: Props = $props()
</script>

{#if isPinned}
	<Icon
		icon="thumbtack"
		size="xs"
		class="text-primary"
	/>
{/if}
